<template>
    <div class="context">
        <div class="header">
            <div class="btn_box">
                <div class="btn nomal_btn" @click="goBack">
                    <i class="el-icon-back"></i>
                    返回
                </div>
            </div>
            <div class="title">{{ viewTitle }}</div>
        </div>

        <div class="main_box">
            <el-form ref="ruleForm" :model="form" :rules="rules" label-width="100px">
                <el-form-item>
                    <el-radio-group v-model="form.dtype" @input="radioChange">
                        <el-radio :label="1">省</el-radio>
                        <el-radio :label="2">市</el-radio>
                        <el-radio :label="3">医院</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="省" v-if="form.dtype == 1">
                    <el-select v-model="form.province" placeholder="请选择省">
                        <el-option
                                v-for="item in city_list"
                                :key="item.value"
                                :label="item.name"
                                :value="item.name"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="省市" v-if="form.dtype >= 2">
                    <el-cascader
                            class="width_220"
                            placeholder="请选择省市"
                            clearable
                            v-model="form.provinceAndCity"
                            :options="city_list"
                            :props="cascader_props"
                            @change="getHospital"
                    ></el-cascader>
                </el-form-item>
                <el-form-item label="医院" v-if="form.dtype == 3">
                    <el-select
                            v-model="form.hospital_id"
                            placeholder="请选择医院"
                            @change="hospitalChange"
                    >
                        <el-option
                                v-for="item in hospitalList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.hospital_id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="使用药物">
                    <el-select v-model="form.drug_code" placeholder="请选择药物">
                        <el-option
                                v-for="item in drug_code_list"
                                :key="item.value"
                                :label="item.name"
                                :value="item.drug_code"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="来源">
                    <el-select v-model="form.source" placeholder="请选择来源">
                        <el-option
                                v-for="item in classification_list"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <!--
                <el-form-item label="有效期">
                    <el-date-picker
                            v-model="form.validTime"
                            type="monthrange"
                            range-separator="至"
                            start-placeholder="开始月份"
                            end-placeholder="结束月份"
                            value-format="yyyy-MM"
                    >
                    </el-date-picker>
                </el-form-item>-->
                <el-form-item>
                    <el-button
                            v-if="viewTitle === '添加清单'"
                            type="primary"
                            @click="submitAdd"
                    >提交
                    </el-button
                    >
                    <el-button v-else type="primary" @click="submitEdit">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import {clone} from "@/global/utils";
    import configs from '../configs'

    export default {
        name: "addView",
        data() {
            const checkPhone = (rule, value, callback) => {
                if (!value) {
                    callback(new Error("请输入手机号！"));
                }
                let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (reg.test(value)) {
                    callback();
                } else {
                    callback(new Error("请输入正确的手机号！"));
                }
            };
            return {
                viewTitle: "添加清单",
                form: {
                    dtype: 1,
                    // hospital: "",
                    hospital_id: "",
                    province: "",
                    provinceAndCity: [],
                    // validTime: "",
                    drug_code: "",
                    source: "",
                },
                rules: {
                    // name: [{ required: true, message: "请输入名称！", trigger: "blur" }],
                    // doctor_code: [
                    //   { required: true, message: "请输入医生编码！", trigger: "blur" },
                    // ],
                    // hospital_id: [
                    //   { required: true, message: "请选择医院！", trigger: "blur" },
                    // ],
                    // office: [{ required: true, message: "请输入科室！", trigger: "blur" }],
                    // profe_title: [
                    //   { required: true, message: "请输入职称！", trigger: "blur" },
                    // ],
                    // phone: [{ required: true, validator: checkPhone, trigger: "blur" }],
                },
                classification_list: configs.classification_list,

                hos_search_input: "",
                hos_search_cascader: [],
                cascader_props: {
                    expandTrigger: "hover",
                    value: "name",
                    label: "name",
                    children: "city_list",
                },

                dialogVisible_doc: false,
                hospitalList: [],
            };
        },
        computed: {
            ...mapState("manageData", ["doctor_data"]),
            ...mapState("comInformationData", ["city_list", "drug_code_list"]),
        },
        mounted() {
            if (this.doctor_data) {
                this.viewTitle = "编辑清单- " + this.doctor_data.name;
                this.form = clone(this.doctor_data);
            } else {
                this.viewTitle = "添加清单";
                this.form = {
                    dtype: 1,
                    // hospital: "",
                    hospital_id: "",
                    province: "",
                    provinceAndCity: [],
                    source: "",
                    drug_code: "",
                };
            }
        },
        methods: {
            goBack() {
                this.$emit("changeTopTab", "tableView");
            },
            radioChange(val) {
                this.form.province = "";
                this.form.provinceAndCity = [];
                this.form.hospital = "";
                this.form.hospital_id = "";
            },
            hospitalChange(val) {
                console.log(val);
            },
            getHospital() {
                if (this.form.dtype !== 3) return;
                console.log("getHospital=========", this.form);
                if (this.form.provinceAndCity.length > 0) {
                    let params = {
                        //       name: this.hos_search_input,
                        province: this.form.provinceAndCity[0]
                            ? this.form.provinceAndCity[0]
                            : "",
                        city: this.form.provinceAndCity[1]
                            ? this.form.provinceAndCity[1]
                            : "",
                        //       page_size: 1000,
                        //       page: 1,
                    };
                    this.httpGet("/hospital", params).then((res) => {
                        this.hospitalList = res.data.data_list;
                        if (res.data.total > 1000) {
                            this.$message.warning(
                                "医院数据搜索结果已超过1000条！请精确搜索条件"
                            );
                        }
                    });
                } else {
                    this.hospitalList = [];
                }
            },

            submitAdd() {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        let params = {
                            dtype: this.form.dtype,
                            // start_month: this.form.validTime[0] ? this.form.validTime[0] : "",
                            // end_month: this.form.validTime[1] ? this.form.validTime[1] : "",
                            drug_code: this.form.drug_code,
                            source: this.form.source,
                            is_excluded: 1 // 是否为排除清单  1否2是
                        };
                        if (this.form.dtype == 1) {
                            params.province = this.form.province;
                        } else if (this.form.dtype == 2 || this.form.dtype == 3) {
                            params.province = this.form.provinceAndCity[0]
                                ? this.form.provinceAndCity[0]
                                : "";
                            params.city = this.form.provinceAndCity[1]
                                ? this.form.provinceAndCity[1]
                                : "";
                            if (this.form.dtype == 3) {
                                params.hospital_id = this.form.hospital_id;
                            }
                        }
                        console.log("params", params);
                        this.httpPost("/visit_list/save", params).then((res) => {
                            this.$message.success("添加成功！");
                            this.goBack();
                        });
                    }
                });
            },
            submitEdit() {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        let params = {
                            ...this.form,
                        };
                        //   this.httpPut(`/doctor/${this.form.user_id}`, params).then((res) => {
                        //     this.$message.success("更新成功！");
                        //     this.goBack();
                        //   });
                    }
                });
            },
        },
    };
</script>

<style scoped lang="scss">
    $view_background: rgb(246, 247, 248);
    $btn_border: rgb(246, 247, 248);
    .context {
        width: 100%;
        height: 100%;
        background: $view_background;
        .header {
            width: 100%;
            line-height: 50px;
            padding: 0 15px;
            box-sizing: border-box;
            display: flex;
            border-bottom: 1px solid #ddd;
            .title {
            }
            .btn_box {
                padding-right: 20px;
                .btn {
                    margin-top: 10px;
                    border: 1px solid $btn_border;
                }
            }
        }

        .main_box {
            padding: 10px;

            .hos_select_box {
                width: 350px;
                border: 1px solid #dcdfe6;
                height: 40px;
                line-height: 40px;
                box-sizing: border-box;
                border-radius: 4px;
                background: #fff;
                display: flex;
                justify-content: space-between;
                padding: 0 15px;
                color: #606266;
                span,
                i {
                    align-self: center;
                }
            }
        }
    }

    .table_box {
        height: 100%;
        box-sizing: border-box;
        .table_search {
            padding: 3px 15px;
            background: #fff;
            display: flex;
            div {
                padding-bottom: 5px;
            }
            .two {
                padding-left: 5px;
            }
        }
        .table {
        }
    }
</style>